export default "__VITE_ASSET__BlP9$JBn__"